var React = require('react');

function Tools (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"#1C73B5","fill":"none","strokeWidth":".8","d":"M2 13h10v10H2V13zm15 0h10v10H17V13zM2 28h10v10H2V28zm15 0h10v10H17V28z"}));
}

Tools.defaultProps = {"viewBox":"0 0 40 40"};

module.exports = Tools;

Tools.default = Tools;
